import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import colors from 'vuetify/es5/util/colors'
import firebase from './utils/firebase'

//Generate excel segundo pluggin
/*
import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);
*/

Vue.use(firebase)

Vue.use(Vuetify, {theme: {
        primary: '#FF6D00',
        secondary: colors.grey.darken1,
        accent: colors.shades.black,
        error: colors.red.accent3
    }})

new Vue({
  el: '#app',
  render: h => h(App),
    store: store,
    router,
})
